var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82207 0.017085C10.6744 0.130985 12.411 1.04218 13.6845 2.29508C15.1896 3.88968 16 5.82598 16 8.10398C16 9.92638 15.3054 11.6349 14.1476 13.1156C12.9899 14.4824 11.3691 15.5075 9.51671 15.8492C7.66434 16.1909 5.81197 15.9631 4.19115 15.0519C2.57032 14.1407 1.29682 12.7739 0.602181 11.0654C-0.0924575 9.35688 -0.208231 7.42058 0.370635 5.71208C0.9495 3.88968 1.99146 2.40898 3.61228 1.38388C5.11733 0.358785 6.9697 -0.096815 8.82207 0.017085ZM9.40094 14.7102C10.906 14.3685 12.2953 13.5712 13.3372 12.3183C14.2634 11.0654 14.8423 9.58468 14.7265 7.99008C14.7265 6.16768 14.0319 4.34528 12.7584 3.09238C11.6006 1.95338 10.2113 1.26998 8.59052 1.15608C7.08547 1.04218 5.46465 1.38388 4.19115 2.29508C2.91764 3.20628 1.99146 4.45918 1.52837 6.05378C1.06527 7.53448 1.06527 9.12908 1.75991 10.6098C2.45455 12.0905 3.49651 13.2295 4.88579 14.0268C6.27506 14.8241 7.89589 15.0519 9.40094 14.7102Z",
    fill: "#303261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81152 4.57343L6.71108 4.09961L11.9209 7.51661V8.46426L6.71108 11.8813L5.81152 11.4074V4.57343ZM6.96925 5.63726V10.3436L10.5571 7.99043L6.96925 5.63726Z",
    fill: "#303261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resumeIcon.f88b274c2c65708508e7856a52291914.svg";
export { ForwardRef as ReactComponent };